import React, { useEffect, useState, useRef } from "react";
import SearchLayout from "../../layouts/SearchLayout";
import SearchBar from "../../components/SearchBar/SearchBar";
import { useDispatch } from "react-redux";
import Logo from "../../components/Logo/Logo";
import { homeActions } from "../../store/store";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { InstantSearch } from "react-instantsearch";
import { searchClient } from "../../services/typesense-client";
import { useAuthContext } from "@asgardeo/auth-react";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  window.dataLayer = window.dataLayer || [];
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const { state, getAccessToken } = useAuthContext();
  const [userToken, setUserToken] = useState("noToken");
  const searchType = sessionStorage.getItem("searchType");

  useEffect(() => {
    dispatch(homeActions.setCurrentPage("home"));
    dispatch(homeActions.setSelectedOption("All"));
    sessionStorage.setItem("searchType", "All");
    sessionStorage.setItem("isEmpty", true);
    sessionStorage.removeItem("searchedQuery");
    sessionStorage.removeItem("isRedirected");

    return () => {
      dispatch(homeActions.setCurrentPage(""));
    }
  }, [dispatch]);

  const handleClick = () => {
    navigate("/search");
    window.dataLayer.push({
      event: "Explore Click",
      event_label: "Explore All button clicked",
    });
  };

  let queryBy;
  let inFix;

  useEffect(() => {
    const fetchToken = async () => {
      if (state.isAuthenticated) {
        const accessToken = await getAccessToken();
        setUserToken(accessToken);
        sessionStorage.setItem("userToken", userToken);
      } else {
        setUserToken("noToken");
      }
    };
    fetchToken();
  }, [state.isAuthenticated, getAccessToken, userToken]);

  if (searchType === "Exact Match") {
    queryBy = "chunk_text";
    inFix = "off";
  } else if (searchType === "Semantic Match") {
    queryBy = "chunk_vec";
    inFix = "off";
  } else if (searchType === "Case Number") {
    queryBy = "standard_casenumber";
    inFix = "always";
  } else if (searchType === "Parties") {
    queryBy = "nameofparties";
    inFix = "off";
  } else {
    queryBy = "chunk_text, chunk_vec";
    inFix = "off";
  }

  const SearchClient = searchClient(queryBy, inFix, userToken);
  const PlaceHolder = isDesktop
    ? "Start typing a legal query, key word, party name, or case number"
    : "Type a legal query or key word";

  return (
    <InstantSearch
      indexName={import.meta.env.VITE_TYPESENSE_COLLECTION_NAME}
      searchClient={SearchClient}
      routing={true}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
    >
      <SearchLayout showSearch={false} showLogo={false} showTab={false}>
        <Helmet>
          <title>paralegal.lk | a search engine for Sri Lankan law</title>
          <meta
            name="description"
            content="Our case law database covers Supreme Court, Court of Appeal and High Court of Civil Appeal plus SLR and NLR law reports."
          />
          <link rel="canonical" href="https://www.paralegal.lk" />
        </Helmet>
        <div className="flex flex-col items-center justify-center px-20 w-full">
          <div className="flex justify-center">
            <Logo />
          </div>

          <div className="flex w-full justify-center my-10 z-10">
            <SearchBar
              PlaceHolder={PlaceHolder}
              enableSuggestions={true}
              enableFiltering={true}
              enableSearchTracking={true}
              SearchAsYouType={true}
            />
          </div>

        {/* Lazy Loaded Text Animation */}
        <div className="z-0 max-w-[800px] w-full justify-between flex animate-pulse dark:text-pl_txt_dark_1 dark:font-extralight bg-gradient-to-br from-[#dd0c7e] via-[#ca1582] to-[#a6208e] text-transparent bg-clip-text uppercase mt-20 m-30 sm:mt-50 sm:mb-60 text-12 text-center px-20 md:px-30">
          {'FAST · CURRENT · RELEVANT'.split('').map((char, index) => (
            <span key={index}>{char}</span>
          ))} 
       </div>
        {/* <Suspense fallback={<p className="text-center text-gray-500 animate-pulse">Loading...</p>}>
          <LazyLoadText />
        </Suspense> */}

          <button
            onClick={handleClick}
            className="z-0 max-w-[200px] w-full h-[40px] rounded-full bg-transparent text-pl_prim_color_1 border-pl_prim_color_1 border font-medium text-16 hover:border-0 hover:text-white hover:bg-gradient-to-br hover:from-[#dd0c7e] hover:via-[#ca1582] hover:to-[#a6208e] transition duration-300 ease-in-out"
          >
            Explore all
          </button>
        </div>
      </SearchLayout>
    </InstantSearch>
  );
};

export default Home;
